import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'
import { Container } from 'rsuite'

interface ProtectedRouteProps {
  children: React.ReactNode
  roles?: string[]
}

function ProtectedRoute({
  children,
  roles,
}: ProtectedRouteProps): React.JSX.Element {
  const {
    isAuthenticated,
    isLoading,
    isAdmin,
    isClient,
    isClientManager,
    isClientUser,
    user,
  } = useAuth()
  const hasRole = (roles: string[]): boolean => {
    if (isAdmin) return true
    if (isClient && isClientManager) return roles.includes('clientManager')
    if (isClient && isClientUser) return roles.includes('clientUser')

    return false
  }

  if (isLoading) {
    if (isAuthenticated && user && (!roles || hasRole(roles))) {
      return <>{children}</>
    }
    return <></>
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" />
  } else if (roles && !hasRole(roles)) {
    return (
      <Container className="m-20">
        <p className="h1 text-danger">Access Denied</p>
        <p>You don't have permission to view this resource.</p>
        <p className="text-danger">Error Code: 403 forbidden</p>
      </Container>
    )
  } else {
    return <>{children}</>
  }
}

export default ProtectedRoute
